<template>
  <div class="ongkir-create-order pb-20 pt-6 px-4 md:px-6 bg-neutral-50 min-h-screen">
    <div class="max-w-6xl mx-auto">
          
      <div class="flex flex-col lg:flex-row gap-6 items-start">
            
        <!-- Kolom Kiri: Informasi Pengirim dan Penerima -->
        <div class="w-full lg:w-2/3">
          <div class="bg-white rounded-xl shadow-sm border border-neutral-200 p-6 mb-6 relative overflow-hidden">
            <div class="absolute left-0 top-0 bottom-0 w-1 bg-red-600"></div>
            <p class="text-lg font-bold text-red-600 mb-5 pl-2">Informasi Pengirim dan Penerima</p>
        
            <div class="mb-6">
              <p class="text-sm text-neutral-500 mb-4 font-medium">Pengirim</p>
              
              <div class="mb-4">
                <label class="text-sm text-neutral-700 mb-1 inline-block">Area (Otomatis Terisi)</label>
                <div class="w-full px-3 py-2.5 rounded-lg border border-neutral-200 bg-neutral-100 text-neutral-600 focus:outline-none">
                  {{ orderData.originSearch || '-' }}
                </div>
              </div>

              <div class="mb-4">
                <label class="text-sm text-neutral-700 mb-1 inline-block">Nama <span class="text-red-500">*</span></label>
                <input type="text" v-model="form.sender_name" placeholder="Contoh: Linknau" class="w-full px-3 py-2.5 rounded-lg border border-neutral-300 focus:outline-none focus:border-primary-500 focus:ring-1 focus:ring-primary-500 transition-colors" />
              </div>
              
              <div class="mb-4">
                <label class="text-sm text-neutral-700 mb-1 inline-block">No. Handphone <span class="text-red-500">*</span></label>
                <input type="text" v-model="form.sender_phone" placeholder="Contoh: 08123456789" class="w-full px-3 py-2.5 rounded-lg border border-neutral-300 focus:outline-none focus:border-primary-500 focus:ring-1 focus:ring-primary-500 transition-colors" />
              </div>
              
              <div class="mb-2">
                <label class="text-sm text-neutral-700 mb-1 inline-block">Alamat <span class="text-red-500">*</span></label>
                <textarea v-model="form.sender_address" placeholder="Tulis alamat detail (nama jalan, patokan, dll)" rows="3" class="w-full px-3 py-2.5 rounded-lg border border-neutral-300 focus:outline-none focus:border-primary-500 focus:ring-1 focus:ring-primary-500 transition-colors resize-none"></textarea>
              </div>
            </div>

            <div class="border-t border-neutral-100 pt-5">
              <p class="text-sm text-neutral-500 mb-4 font-medium">Penerima</p>
              
              <div class="mb-4">
                <label class="text-sm text-neutral-700 mb-1 inline-block">Area (Otomatis Terisi)</label>
                <div class="w-full px-3 py-2.5 rounded-lg border border-neutral-200 bg-neutral-100 text-neutral-600 focus:outline-none">
                  {{ orderData.destinationSearch || '-' }}
                </div>
              </div>

              <div class="mb-4">
                <label class="text-sm text-neutral-700 mb-1 inline-block">Nama <span class="text-red-500">*</span></label>
                <input type="text" v-model="form.receiver_name" placeholder="Contoh: Budi" class="w-full px-3 py-2.5 rounded-lg border border-neutral-300 focus:outline-none focus:border-primary-500 focus:ring-1 focus:ring-primary-500 transition-colors" />
              </div>
              
              <div class="mb-4">
                <label class="text-sm text-neutral-700 mb-1 inline-block">No. Handphone <span class="text-red-500">*</span></label>
                <input type="text" v-model="form.receiver_phone" placeholder="Contoh: 08123456789" class="w-full px-3 py-2.5 rounded-lg border border-neutral-300 focus:outline-none focus:border-primary-500 focus:ring-1 focus:ring-primary-500 transition-colors" />
              </div>
              
              <div class="mb-2">
                <label class="text-sm text-neutral-700 mb-1 inline-block">Alamat <span class="text-red-500">*</span></label>
                <textarea v-model="form.receiver_address" placeholder="Tulis alamat detail (nama jalan, patokan, dll)" rows="3" class="w-full px-3 py-2.5 rounded-lg border border-neutral-300 focus:outline-none focus:border-primary-500 focus:ring-1 focus:ring-primary-500 transition-colors resize-none"></textarea>
              </div>
            </div>
          </div>
        </div>

        <!-- Kolom Kanan: Informasi Layanan -->
        <div class="w-full lg:w-1/3">
          <div class="bg-white rounded-xl shadow-sm border border-neutral-200 p-6 mb-6">
            <p class="text-lg font-bold text-neutral-800 mb-5">Informasi Layanan</p>
            
            <div class="mb-5 border-b border-neutral-100 pb-5">
              <div class="flex justify-between items-center">
                <div class="flex items-center gap-3">
                  <div class="w-16 h-12 bg-neutral-50 border border-neutral-100 rounded-md flex items-center justify-center p-1">
                    <img :src="orderData.service ? orderData.service.logo : ''" alt="Logo" class="max-h-8 object-contain" v-if="orderData.service && orderData.service.logo" />
                  </div>
                  <div class="flex flex-col gap-1">
                    <p class="font-bold text-neutral-800">{{ orderData.service ? orderData.service.name : '-' }}</p>
                    <p class="text-sm text-neutral-500">{{ orderData.service ? orderData.service.package.name : '-' }}</p>
                  </div>
                </div>
                <p class="font-bold text-lg text-neutral-800">{{ orderData.service ? $options.filters.currencyFormat(orderData.service.package.final_cost) : 'Rp 0' }}</p>
              </div>
            </div>

            <!-- Jenis Paket -->
            <div class="mb-5 border-b border-neutral-100 pb-5 custom-select">
              <label class="text-sm text-neutral-700 mb-2 inline-block">Jenis Paket <span class="text-red-500">*</span></label>
              <v-select
                :options="goodsCategories"
                placeholder="Pilih jenis paket"
                :reduce="selectedPackage => selectedPackage.code"
                label="name"
                v-model="form.goods_content"
                class="v-select-custom"
              />
            </div>

            <!-- Dimensi Paket -->
            <div>
              <div class="flex justify-between items-center mb-4">
                <p class="text-sm text-neutral-500 font-medium">Dimensi Paket</p>
                <div class="bg-teal-50 px-3 py-1 rounded-full border border-teal-100 text-teal-700 text-sm font-medium">
                  Berat Aktual: {{ orderData.package_weight ? orderData.package_weight + ' Kg' : '-' }}
                </div>
              </div>

              <!-- Input PxLxT -->
              <div class="flex gap-3 mb-4">
                <div class="flex-1">
                  <label class="text-xs text-neutral-500 mb-1 block">Panjang (cm) <span class="text-red-500">*</span></label>
                  <input type="number" v-model="form.length" class="w-full px-3 py-2 rounded-lg border border-neutral-300 focus:outline-none focus:border-primary-500 text-sm" placeholder="P" />
                </div>
                <div class="flex-1">
                  <label class="text-xs text-neutral-500 mb-1 block">Lebar (cm) <span class="text-red-500">*</span></label>
                  <input type="number" v-model="form.width" class="w-full px-3 py-2 rounded-lg border border-neutral-300 focus:outline-none focus:border-primary-500 text-sm" placeholder="L" />
                </div>
                <div class="flex-1">
                  <label class="text-xs text-neutral-500 mb-1 block">Tinggi (cm) <span class="text-red-500">*</span></label>
                  <input type="number" v-model="form.height" class="w-full px-3 py-2 rounded-lg border border-neutral-300 focus:outline-none focus:border-primary-500 text-sm" placeholder="T" />
                </div>
              </div>

              <!-- Info Berat Volume -->
              <div v-if="volumeWeight > 0" class="flex justify-between items-center mb-4 bg-neutral-50 px-3 py-2 rounded-lg border border-neutral-100">
                <p class="text-sm text-neutral-500">Berat Volume</p>
                <p class="text-sm font-bold text-neutral-700">{{ volumeWeight }} Kg</p>
              </div>
            </div>
          </div>

          <div class="flex justify-end mt-6">
            <Button buttonText="Lanjutkan" type="primary" :class="'big_full'" @action="submitOrderModal" :disabled="!isValidForm" />
          </div>
        </div>

      </div>

    </div>

    <!-- Modal Konfirmasi Berat Volume -->
    <Modal :modalVisible="visibleVolumeModal" @close="closeVolumeModal" id="volume-confirmation-modal">
      <template slot="modal-content">
        <div class="p-6">
          <p class="text-sm text-neutral-600 mb-6">
            Berat volume (<strong>{{ volumeWeight }} Kg</strong>) melebihi berat aktual (<strong>{{ orderData.package_weight }} Kg</strong>), apakah Anda ingin melanjutkan untuk memperbarui harga ongkir ?
          </p>
          <div class="flex justify-end gap-3">
            <Button buttonText="Batal" type="secondary" @action="closeVolumeModal" />
            <Button buttonText="Lanjutkan" type="primary" :disabled="recheckLoading" @action="proceedVolumeWeight" />
          </div>
        </div>
      </template>
    </Modal>

    <!-- Checkout / Payment Modal -->
    <Modal :modalVisible="showCheckoutModal" @close="showCheckoutModal = false" id="checkout-modal" width="550px" :overflowAuto="true">
      <template slot="modal-content">
        <div class="flex justify-between items-center mb-6 border-b border-neutral-200 pb-4">
          <p class="font-bold text-xl text-neutral-800">Rincian & Pembayaran</p>
        </div>

        <!-- Ekspedisi Info -->
        <div class="border border-gray-300 mb-6 rounded-xl p-4 bg-white shadow-sm flex justify-between items-center" v-if="orderData.service">
          <div class="flex items-center gap-4">
            <div class="w-16 h-12 bg-neutral-50 border border-neutral-100 rounded-md flex items-center justify-center p-1">
              <img :src="orderData.service.logo" class="max-h-10 object-contain" v-if="orderData.service.logo" />
              <LogisticPlaceholder :logisticName="orderData.service.name" v-else />
            </div>
            <div>
              <p class="font-bold text-neutral-800 text-sm">{{ orderData.service.package.name }}</p>
              <p class="text-xs text-neutral-500 mt-1 flex items-center gap-1 font-medium">
                <Time width="12" height="12" color="neutral-500" /> {{ orderData.service.package.est_delivery_time_range_min }} - {{ orderData.service.package.est_delivery_time_range_max }}
              </p>
            </div>
          </div>
          <div class="text-right">
            <p class="text-base font-bold text-primary-600">{{ orderData.service.package.final_cost | currencyFormat }}</p>
          </div>
        </div>

        <!-- Asuransi -->
        <div v-if="orderData.service && orderData.service.package.has_insurace" class="border border-gray-300 mb-6 rounded-xl overflow-hidden shadow-sm bg-white">
          <div class="p-4 flex justify-between items-center gap-4" :class="{ 'border-b border-gray-300 bg-neutral-50': insurance }">
            <div class="flex flex-col flex-1">
              <p class="text-sm font-bold text-neutral-800">{{ $t('order.createOrder.stepTwo.insurance') }}</p>
              <p class="text-xs text-neutral-500 mt-1" v-if="!insurance">Lindungi paket dari kerusakan/kehilangan</p>
            </div>
            <div class="w-12 flex-shrink-0 flex justify-end">
              <Toggle id="insurance" v-model="insurance" />
            </div>
          </div>
          <div class="p-4 bg-white" v-if="insurance">
            <label class="text-sm text-neutral-700 font-medium mb-2 block">
              {{ $t('order.createOrder.stepTwo.goodsValue') }}
            </label>
            <CurrencyInput :ref="'priceField'" :options="{ currency: 'IDR' }" @change="goodsValue = $event" :placeholder="$t('order.createOrder.stepTwo.goodsValuePlaceholder')" />
            <div class="mt-4 pt-4 border-t border-dashed border-neutral-200 flex justify-between items-center">
              <p class="text-sm text-neutral-600">{{ $t('order.createOrder.stepTwo.insuranceCost') }}</p>
              <p class="text-sm font-bold text-neutral-800">{{ costOfInsurance | currencyFormat }}</p>
            </div>
          </div>
        </div>

        <!-- Rincian Biaya -->
        <div class="border border-gray-300 mb-6 rounded-xl p-4 bg-white shadow-sm">
          <p class="font-bold text-sm mb-4 text-neutral-800">Rincian Biaya</p>
          <div class="flex justify-between items-center mb-3">
            <p class="text-sm text-neutral-500">Layanan Pengiriman</p>
            <p class="text-sm font-medium text-neutral-800">{{ orderData.service?.package?.final_cost | currencyFormat }}</p>
          </div>
          <div class="flex justify-between items-center mb-3" v-if="insurance">
            <p class="text-sm text-neutral-500">Biaya Asuransi</p>
            <p class="text-sm font-medium text-neutral-800">{{ costOfInsurance | currencyFormat }}</p>
          </div>
          <div class="border-t border-gray-300 mt-4 pt-4 flex justify-between items-center bg-primary-50 -mx-4 -mb-4 px-4 py-3 rounded-b-xl">
            <p class="font-bold text-neutral-800">Total Pembayaran</p>
            <p class="font-bold text-lg text-primary-600">{{ totalCost | currencyFormat }}</p>
          </div>
        </div>

        <!-- Metode Pembayaran -->
        <div class="mb-6" v-if="!user?.is_upgraded">
          <p class="font-bold text-sm mb-3 text-neutral-800">Metode Pembayaran</p>
          <div class="flex gap-4">
            <div class="border rounded-xl p-4 flex-1 flex items-center justify-center cursor-pointer transition-all duration-200 hover:shadow-md" :class="{'border-primary-500 bg-primary-50 ring-2 ring-primary-500 ring-opacity-50': paymentType === 'qris', 'border-gray-300 bg-white hover:border-primary-300': paymentType !== 'qris'}" @click="paymentType = 'qris'">
              <label class="flex flex-col items-center gap-2 w-full cursor-pointer">
                <input type="radio" name="paymentTypeModal" value="qris" v-model="paymentType" class="hidden" />
                <img src="@/assets/images/icons/qris.svg" class="h-6 object-contain" />
                <span class="text-xs font-medium text-neutral-600" :class="{'text-primary-700': paymentType === 'qris'}">QRIS</span>
              </label>
            </div>
            <div class="border rounded-xl p-4 flex-1 flex flex-col justify-center cursor-pointer transition-all duration-200 hover:shadow-md" :class="{'border-primary-500 bg-primary-50 ring-2 ring-primary-500 ring-opacity-50': paymentType === 'transfer', 'opacity-50 cursor-not-allowed bg-neutral-50': totalCost < 80000, 'border-gray-300 bg-white hover:border-primary-300': paymentType !== 'transfer' && totalCost >= 80000}" @click="totalCost >= 80000 ? paymentType = 'transfer' : null">
              <label class="flex flex-col items-center gap-2 w-full cursor-pointer" :class="{'cursor-not-allowed': totalCost < 80000}">
                <input :disabled="totalCost < 80000" type="radio" name="paymentTypeModal" value="transfer" v-model="paymentType" class="hidden" />
                <span class="font-bold text-sm text-neutral-700" :class="{'text-primary-700': paymentType === 'transfer'}">Bank Transfer</span>
              </label>
              <p class="text-red-500 text-[10px] mt-1 text-center w-full" v-if="totalCost < 80000">
                Min. Belanja Rp 80.000
              </p>
            </div>
          </div>
        </div>

        <div class="mt-4 pt-6 pb-2 border-t border-gray-200">
          <Button :disabled="(!user?.is_upgraded && !paymentType)" buttonText="Lanjutkan Pembayaran" type="primary" size="big_full" @action="processSubmitOrder()" />
        </div>
      </template>
    </Modal>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { currencyFormat } from '@/util/currency'
import Toggle from '@/components/Toggle/Toggle'
import CurrencyInput from '@/components/Forms/CurrencyInput'
import Time from '@/components/Icons/Time'
import LogisticPlaceholder from '@/components/Icons/LogisticPlaceholder'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'

export default {
  name: 'OngkirCreateOrder',
  filters: { currencyFormat },
  components: {
    Button: () => import('@/components/Forms/Button'),
    Modal: () => import('@/components/Modal/Modal'),
    Toggle,
    CurrencyInput,
    Time,
    LogisticPlaceholder,
    vSelect
  },
  data() {
    return {
      orderData: {
        service: null,
        originSearch: '',
        destinationSearch: '',
        package_weight: null,
        originInformation: null,
        destinationInformation: null
      },
      showCheckoutModal: false,
      paymentType: null,
      insurance: false,
      goodsValue: null,
      form: {
        goods_content: null,
        sender_name: '',
        sender_phone: '',
        sender_address: '',
        receiver_name: '',
        receiver_phone: '',
        receiver_address: '',
        length: '',
        width: '',
        height: ''
      },
      isVolumeAccepted: false,
      recheckLoading: false,
      visibleVolumeModal: false,
      volumeDebounce: null
    }
  },
  computed: {
    ...mapGetters('auth', ['userData']),
    ...mapGetters('master', ['goodsCategories']),
    ...mapGetters('common', ['ongkirList']),
    user() {
      return this.userData?.user
    },
    totalCost() {
      let cost = this.orderData.service?.package?.final_cost || 0
      if (this.insurance) {
        cost += this.costOfInsurance
      }
      return cost
    },
    costOfInsurance() {
      if (!this.insurance || !this.orderData.service) return 0
      
      const serviceName = this.orderData.service.name || ''
      if (serviceName.includes('JNE')) {
        return Math.ceil(this.goodsValue * 0.002 + 5000)
      }
      if (serviceName.toLowerCase().includes('lion')) {
        return Math.ceil((this.goodsValue * 0.27) / 100)
      }
      if (serviceName.includes('J&T Cargo')) {
        if (this.goodsValue <= 2500000) {
          return 5000
        }
        return Math.ceil(this.goodsValue * 0.002)
      }
      if (this.goodsValue >= 1000000) {
        return Math.ceil(this.goodsValue * 0.0025)
      }
      return 2500
    },
    volumeWeight() {
      const p = parseFloat(this.form.length || 0)
      const l = parseFloat(this.form.width || 0)
      const t = parseFloat(this.form.height || 0)
      return Math.ceil((p * l * t) / 6000)
    },
    isVolumeGreater() {
      const actualWeight = parseFloat(this.orderData.package_weight || 0)
      return this.volumeWeight > actualWeight
    },
    isValidForm() {
      return (
        this.form.goods_content &&
        this.form.sender_name &&
        this.form.sender_phone &&
        this.form.sender_address &&
        this.form.receiver_name &&
        this.form.receiver_phone &&
        this.form.receiver_address &&
        this.form.length &&
        this.form.width &&
        this.form.height
      )
    }
  },
  watch: {
    volumeWeight(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.isVolumeAccepted = false;
        clearTimeout(this.volumeDebounce);
        if (this.isVolumeGreater) {
          this.volumeDebounce = setTimeout(() => {
            if (this.isVolumeGreater && !this.isVolumeAccepted && !this.visibleVolumeModal) {
              this.visibleVolumeModal = true;
            }
          }, 800);
        }
      }
    }
  },
  mounted() {
    this.loadOrderData()
    this.getGoodsCategories()
  },
  methods: {
    ...mapActions('common', ['showLoading', 'hideLoading', 'ongkir']),
    ...mapActions('merchant', ['createOrder']),
    ...mapActions('master', ['getGoodsCategories']),
    loadOrderData() {
      const stored = sessionStorage.getItem('ongkirOrderData')
      if (stored) {
        this.orderData = JSON.parse(stored)
      } else {
        this.$router.push('/ongkir')
      }
    },
    recheckOngkir() {
      return new Promise((resolve, reject) => {
        this.recheckLoading = true;
        this.showLoading();
        const constructedPayload = {
          page: 1,
          per_page: 100,
          search_keyword: '',
          sort: 'ASC',
          origin_city: this.orderData.originInformation?.code,
          destination_city: this.orderData.destinationInformation?.code,
          service_ids: this.orderData.service?.logistic_id,
          package_weight: this.volumeWeight,
          is_require_pod: false
        }
        
        this.ongkir({ params: constructedPayload }).then(() => {
          // Find matching package
          if (this.ongkirList && this.ongkirList.length > 0) {
            const updatedLogistic = this.ongkirList.find(o => o.id === this.orderData.service?.logistic_id)
            if (updatedLogistic) {
              const updatedPackage = updatedLogistic.packages.find(p => p.id === this.orderData.service?.package?.id)
              if (updatedPackage) {
                this.orderData.service.package = updatedPackage;
                this.orderData.package_weight = this.volumeWeight;
                sessionStorage.setItem('ongkirOrderData', JSON.stringify(this.orderData));
                this.isVolumeAccepted = true;
                this.$toast.open({ type: 'success', message: 'Ongkos kirim berhasil diperbarui berdasarkan berat volume' });
                resolve(true);
                return;
              }
            }
          }
          reject(new Error('Gagal mencocokkan layanan kurir'));
        }).catch((err) => {
          this.$toast.open({ type: 'error', message: err?.response?.data?.message || 'Gagal mengecek ulang ongkos kirim' });
          reject(err);
        }).finally(() => {
          this.recheckLoading = false;
          this.hideLoading();
        });
      });
    },
    async proceedVolumeWeight() {
      try {
        this.closeVolumeModal();
        await this.recheckOngkir();
      } catch (error) {
        // Error handled in recheckOngkir
      }
    },
    closeVolumeModal() {
      this.visibleVolumeModal = false;
    },
    submitOrderModal() {
      if (!this.isValidForm) return
      
      if (this.isVolumeGreater && !this.isVolumeAccepted) {
        this.visibleVolumeModal = true;
        return;
      }
      this.showCheckoutModal = true;
    },
    processSubmitOrder() {
      const payloads = {
        is_advance_pickup: false,
        is_require_pod: false,
        sender: {
          name: this.form.sender_name,
          phone_number: `62${this.form.sender_phone.replace(/^0+/, '')}`,
          location_code: this.orderData.originInformation?.code,
          location_coordinate: '',
          address: this.form.sender_address,
          detail_address: ''
        },
        service_id: this.orderData.service?.package?.delivery_service_id,
        service_type: this.orderData.service?.package?.service_type,
        service_category: 'REG',
        service_package_id: this.orderData.service?.package?.id,
        order_type: 'DELPKG',
        packages: [
          {
            category: this.form.goods_content,
            dimension: `${this.form.length}x${this.form.width}x${this.form.height}`,
            dimension_type: 'custom',
            weight: parseFloat(this.orderData.package_weight || 0),
            has_dangerous_goods: false,
            has_glass: false,
            goods_description: '',
            has_high_value: false,
            has_document: false,
            has_electronic: false,
            receiver: {
              name: this.form.receiver_name,
              phone_number: `62${this.form.receiver_phone.replace(/^0+/, '')}`,
              location_code: this.orderData.destinationInformation?.code,
              location_coordinate: '',
              address: this.form.receiver_address,
              detail_address: ''
            }
          }
        ],
        pickup_detail: {
          service_id: '',
          service_package_id: '',
          pickup_time: ''
        },
        transit_detail: {
          transit_place_id: '',
          place_location_code: '',
          place_location_coords: ''
        },
        goods_value: this.goodsValue,
        insurance_cost: this.costOfInsurance,
        enabled_payments: this.paymentType
      }
      
      this.showLoading()
      this.createOrder({ payloads }).then(res => {
        this.hideLoading()
        this.showCheckoutModal = false
        if (res.data.data.is_advance_payment) {
          this.handlePay(res.data.data)
        } else {
          this.$toast.open({ type: 'success', message: 'Order berhasil dibuat' })
          this.$router.push('/order')
        }
      }).catch((err) => {
        this.hideLoading()
        this.$toast.open({ type: 'error', message: err?.response?.data?.message || 'Terjadi kesalahan' })
      })
    },
    handlePay(response) {
      const self = this
      localStorage.setItem('order', JSON.stringify(response))
      localStorage.setItem('payment_finish_url', JSON.stringify(response.payment_finish_url))
      window.snap.pay(response.payment_token, {
        onSuccess: function() {
          self.showLoading()
          setTimeout(() => { self.$router.push(`/order`); self.hideLoading() }, 1000)
        },
        onPending: function() {
          self.showLoading()
          setTimeout(() => { self.$router.push(`/order`); self.hideLoading() }, 1000)
        },
        onError: function() {
          self.showLoading()
          setTimeout(() => { self.$router.push(`/order`); self.hideLoading() }, 1000)
        },
        onClose: function() {
          self.$router.push(`/order`)
        }
      })
    }
  }
}
</script>

<style scoped>
.custom-select >>> .vs__dropdown-toggle {
  padding: 8px;
  border-radius: 0.5rem;
  border-color: #D1D5DB;
}
.custom-select >>> .vs__search::placeholder {
  color: #9CA3AF;
}
</style>
